module.exports = __webpack_public_path__ + "static/media/Profile_0.432a579a.svg";